"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimulationInterface = exports.EdiabasTimeoutError = void 0;
const EdiabasInterface_1 = require("./EdiabasInterface");
class EdiabasTimeoutError extends Error {
    constructor(message = "Receive timed out") {
        super(message);
        this.name = "EdiabasTimeoutError";
    }
}
exports.EdiabasTimeoutError = EdiabasTimeoutError;
class SimulationInterface extends EdiabasInterface_1.EdiabasInterface {
    responses = new Map();
    responseQueue = [];
    frequentBuffer = null;
    pendingReceivers = [];
    ports = new Map();
    _ignitionVoltage = 0;
    // Default 12000 mV mirrors EdiabasLib's `UbatVoltageSimulation` — the
    // value real scripts (e.g. UTILITY.PRG STATUS_UBATT) expect when no
    // physical cable is in play.
    _batteryVoltage = 12000;
    _loopTest = 0;
    _programVoltage = 0;
    _siRelaisTime = 0;
    async connect() {
        this.connected = true;
    }
    async disconnect() {
        this.connected = false;
        this.flushPending(new Error("Disconnected"));
    }
    async send(data) {
        this.assertConnected();
        const key = this.toKey(data);
        const response = this.responses.get(key);
        if (!response) {
            return;
        }
        this.enqueueResponse(response);
    }
    async receive(timeoutMs = 0) {
        this.assertConnected();
        const queued = this.responseQueue.shift();
        if (queued) {
            return queued;
        }
        return new Promise((resolve, reject) => {
            const pending = { resolve, reject };
            if (timeoutMs > 0) {
                pending.timer = setTimeout(() => {
                    this.removePending(pending);
                    reject(new EdiabasTimeoutError());
                }, timeoutMs);
            }
            this.pendingReceivers.push(pending);
        });
    }
    async transmitFrequent(data) {
        this.assertConnected();
        this.frequentBuffer = data;
    }
    async receiveFrequent() {
        this.assertConnected();
        return this.frequentBuffer ?? new Uint8Array(0);
    }
    async stopFrequent() {
        this.frequentBuffer = null;
    }
    getPort(index) {
        return this.ports.get(index) ?? 0;
    }
    setPort(index, value) {
        this.ports.set(index, value);
    }
    get ignitionVoltage() {
        return this._ignitionVoltage;
    }
    get batteryVoltage() {
        return this._batteryVoltage;
    }
    setBatteryVoltage(value) {
        this._batteryVoltage = value;
    }
    get loopTest() {
        return this._loopTest;
    }
    setProgramVoltage(value) {
        this._programVoltage = value;
    }
    rawData(request) {
        this.assertConnected();
        const key = this.toKey(request);
        return this.responses.get(key) ?? new Uint8Array();
    }
    switchSiRelais(time) {
        this._siRelaisTime = time;
    }
    setResponse(request, response) {
        const key = this.toKey(request);
        this.responses.set(key, this.toBytes(response));
    }
    enqueueResponse(response) {
        const pending = this.pendingReceivers.shift();
        if (!pending) {
            this.responseQueue.push(response);
            return;
        }
        if (pending.timer) {
            clearTimeout(pending.timer);
        }
        pending.resolve(response);
    }
    flushPending(error) {
        for (const pending of this.pendingReceivers.splice(0)) {
            if (pending.timer) {
                clearTimeout(pending.timer);
            }
            pending.reject(error);
        }
    }
    removePending(pending) {
        const index = this.pendingReceivers.indexOf(pending);
        if (index >= 0) {
            this.pendingReceivers.splice(index, 1);
        }
    }
    toBytes(data) {
        return data instanceof Uint8Array ? data : Uint8Array.from(data);
    }
    toKey(data) {
        const bytes = this.toBytes(data);
        let hex = "";
        for (const value of bytes) {
            hex += value.toString(16).padStart(2, "0");
        }
        return hex;
    }
    assertConnected() {
        if (!this.connected) {
            throw new Error("Not connected");
        }
    }
}
exports.SimulationInterface = SimulationInterface;
//# sourceMappingURL=SimulationInterface.js.map